import { onMounted, unref } from 'vue'
import { restCursor, changeCursorToResize } from './cursor'
import { setTableRowsHeight } from '@/utils/store-table-size'
import { debounce } from 'lodash'
const setTableRowsHeightDebounce = debounce(setTableRowsHeight, 100)
export default function useResizeRowsHeight (tableRef, rows, resizeLineHorizontalRef, resizeLineHorizontalBolderRef, addBodyHoverEventListener, removeBodyHoverEventListener, tableId) {
  let originClientY = 0
  let offestXToTable = 0
  const minHeight = 40
  // const maxHeight = 450
  onMounted(() => {
    const table = unref(tableRef)
    table.addEventListener('mousedown', e => {
      const { target } = e
      if (target.className.indexOf && target.className.indexOf('bottom') >= 0) {
        removeBodyHoverEventListener()
        originClientY = e.clientY
        // resizeLineHorizontalRef
        const tableView = table.getBoundingClientRect()
        const targetView = target.getBoundingClientRect()
        offestXToTable = targetView.top - tableView.top
        resizeLineHorizontalRef.value.style.display = 'block'
        resizeLineHorizontalRef.value.style.top = `${offestXToTable + 2}px`
        resizeLineHorizontalBolderRef.value.style.display = 'block'
        resizeLineHorizontalBolderRef.value.style.top = `${offestXToTable}px`
        resizeLineHorizontalBolderRef.value.style.left = `${targetView.left - tableView.left}px`
        resizeLineHorizontalBolderRef.value.style.width = `${targetView.width}px`
        // resizeLineHorizontalRef
        const fn = mousemoveHandlerForRow(target.parentNode)
        table.addEventListener('mousemove', fn)
        document.addEventListener('mouseup', () => {
          table.removeEventListener('mousemove', fn)
          resizeLineHorizontalRef.value.style.display = 'none'
          resizeLineHorizontalBolderRef.value.style.display = 'none'
          addBodyHoverEventListener()
        }, { once: true })
        document.addEventListener('mouseleave', () => {
          table.removeEventListener('mousemove', fn)
          resizeLineHorizontalRef.value.style.display = 'none'
          resizeLineHorizontalBolderRef.value.style.display = 'none'
        }, { once: true })
        changeCursorToResize('row')
      }
    })
  })
  const mousemoveHandlerForRow = el => {
    return e => {
      const clientY = e.clientY
      const moveDistance = clientY - originClientY
      const index = el.attributes.bottomIndex.value
      originClientY = clientY
      // const height = el.offsetHeight + moveDistance
      const height = rows.value[index] + moveDistance
      // if (height < minHeight || height > maxHeight) {
      if (height < minHeight) {
        return
      }
      rows.value[index] = height
      setTableRowsHeightDebounce(tableId.value, JSON.stringify(rows.value))
      // resizeLineHorizontalRef begin
      offestXToTable += moveDistance
      resizeLineHorizontalRef.value.style.top = `${offestXToTable + 2}px`
      resizeLineHorizontalBolderRef.value.style.top = `${offestXToTable}px`
      if (window.innerHeight - e.clientY < 72 && moveDistance >= 0) {
        tableRef.value.scrollTop += moveDistance
      }
      // resizeLineHorizontalRef end
      restCursor()
    }
  }
}
